import React from 'react'
import { Vertical, Horizontal, Texto } from '@gravitate-js/excalibrr'

export const Details = ({ selectedProduct }) => {
  return (
    <Horizontal background='bg-2' verticalCenter className='p-3' border='bottom' flex={'none'}>
      <Vertical flex={1}>
        <Texto appearance='medium' weight='bold'>
          PRODUCT NAME
        </Texto>
        <Texto appearance='secondary' category='h4' weight='bold'>
          {selectedProduct.name}
        </Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto appearance='medium' align='right' weight='bold'>
          GROUP
        </Texto>
        <Texto appearance='secondary' category='h4' align='right' weight='bold'>
          {selectedProduct.group}
        </Texto>
      </Vertical>
    </Horizontal>
  )
}
